module.exports = "<div button text=\"Карта\" classes=\"filter__map-draw-trigger filter__popup-trigger\"\n     is-popup-open=\"mapDraw.isPopupOpen\"\n     button-style=\"{$ mapDraw.isPopupOpen?'solid':'bright' $}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/map-draw/templates/map-draw.html
// module id = 423
// module chunks = 0